import { CLEAR_ENUM_DATA, LOAD_ENUMS_DATA, SET_ENUMS_DATA } from "./constants";
import { EnumKey, EnumTypeWithKey, IClearEnumAction, ILoadEnumsAction, ISetEnumsAction } from "./types";

/**
 * Pro zadaný klíč spustí načítání dat týkající se enumů.
 * @param enumsKeys klíče enumů, respektive jejich názvy, pro které budou data načtena
 * @param enableBatching příznak, zda se má využít batchování akcí. Výchozí hodnota je false. Batchování umožňuje zpracovat akce následující krátce za sebou najednou,
 * čímž šetří výkon. Nehodí se pro osamocené akce, kde nepřinese benefit výkonu a pouze prodlouží načtení o dobu čekání na následné akce.
 */
export const createLoadEnumsAction = (enumsKeys: ReadonlyArray<EnumKey>, enableBatching = false): ILoadEnumsAction => ({
    type: LOAD_ENUMS_DATA,
    payload: {
        enumsKeys,
        enableBatching,
    },
});

/**
 * Uloží do reduxu data týkající se enumu pro zadaný klíč.
 * @param enumTypesWithKeys pole objektů obsahujících reduxové typy enumů a klíče k jejich identifikaci v reduxu
 */
export const createSetEnumsAction = (enumTypesWithKeys: ReadonlyArray<EnumTypeWithKey>): ISetEnumsAction => ({
    type: SET_ENUMS_DATA,
    payload: {
        enumTypesWithKeys,
    },
});

/**
 * Odstraní data pro enum ná základě zadaného klíče.
 *
 * @param enumsKey klíč k identifikaci dat týkajících se enumu
 */
export const createClearEnumAction = (enumsKey: EnumKey): IClearEnumAction => ({
    type: CLEAR_ENUM_DATA,
    payload: {
        enumsKey,
    },
});
